import tracking from '@titanio/lead-tracking'

const mount = () => {
  tracking.mount()
  tracking.setEventListenerFlow()
}

export default { mount }
